import { useEffect, useState } from 'react';
import ViewReverse from './ViewReverse';
import images from '../constants/images';
import { cn, getContentKeyAccToLang } from '../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import Text from './Text';
import dynamicfunction from '../utils/dynamicfunction';
import { fontSizes } from '../constants/constants';
import Button from './Button';
import icons from '../constants/icons';
import Language from './Language';
import { tabsMenu } from '../config/config';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import MobileMenu from './MobileMenu';
import NotificationModal from './NotificationModal';
import AlertModal from './AlertModal';
import ConfirmModal from './ConfirmModal';
import { getClientData } from '../store/actions/investmentsAction';
import { setFetchedClient } from '../store/slices/investmentsSlice';
import { logoutUser } from '../store/actions/authActions';
import ClientDetailModal from './ClientDetailModal';
import ViewItems from './ViewItems';
import LoaderModal from './LoaderModal';
import { setApplicantType, setClientApplicantId, setClientApplicationId, setClientId, setRejectionMsg } from '../store/slices/constantSlice';

const DashboardHeader = () => {
  const dispatch = useDispatch();
  const pathname = useLocation();
  const navigate = useNavigate();

  const { isArabic, TextWeight } = dynamicfunction();

  const { dashboardContent, languageLoading } = useSelector((state) => state.content);
  const { authLoading } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.common);
  const { clientDetails, fetchedClient } = useSelector((state) => state.investments);
  const { client_application_id } = useSelector((state) => state.constant);

  const [isDrawer, setIsDrawer] = useState(false);
  const [isNotificationModal, setIsNotificationModal] = useState(false);
  const [isAlertModal, setIsAlertModal] = useState(false);
  const [targetEl, setTargetEl] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [clientDetailModal, setClientDetailModal] = useState(false);

  const isCorporateForm = pathname?.pathname === '/corporate-form';
  const isIndividualForm = pathname?.pathname === '/individual-form';

  useEffect(() => {
    if (!fetchedClient && user?.accessToken && !isCorporateForm && !isIndividualForm) {
      dispatch(getClientData());
      dispatch(setFetchedClient(true));
    }
  }, []);

  const toogleConfirmModal = () => setConfirmModal(!confirmModal);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(dashboardContent, key, isArabic);
  };

  const handleLogout = () => {
    if (user) {
      dispatch(logoutUser(() => toogleConfirmModal()));
    } else {
      dispatch(setApplicantType(null));
      dispatch(setClientApplicationId(null));
      dispatch(setClientApplicantId(null));
      dispatch(setClientId(null));
      dispatch(setRejectionMsg(null));
      navigate('/funds/available-funds');
    }
  };

  const toogleDrawer = () => setIsDrawer(!isDrawer);
  const toogleNotificationModal = () => setIsNotificationModal(!isNotificationModal);
  const toogleAlertModal = () => setIsAlertModal(!isAlertModal);

  return (
    <div>
      <ViewReverse className={'p-4 justify-between bg-primary py-6 px-5 sm:px-10 md:px-20 fixed top-0 z-[1000] w-full shadow'}>
        <ViewReverse className={'items-center gap-20'}>
          <img src={images.logoWhite} className='w-16 h-16' />

          <ViewReverse className='hidden xl:flex gap-10'>
            {user && !isCorporateForm && !isIndividualForm && (
              <ViewReverse className={'flex items-center gap-3'}>
                {tabsMenu(pathname?.pathname)?.map((item, index) => {
                  const is_suspended = item?.key == 'cash_management' && user?.isClientSuspended;
                  return (
                    <div
                      className={cn('py-2 px-4 rounded-md', item?.isActive ? 'bg-white' : 'bg-transparent opacity-100 cursor-pointer')}
                      onClick={() => navigate(`${is_suspended ? item?.suspended_route : item?.route}`)}
                      key={index}
                    >
                      <Text text={getContentKey(item?.key)} size={fontSizes.h14} color={item?.isActive ? 'text-black' : 'text-white'} />
                    </div>
                  );
                })}
              </ViewReverse>
            )}
          </ViewReverse>
        </ViewReverse>

        <ViewReverse className={cn(' items-center', user ? 'justify-between' : 'justify-end')}>
          <ViewReverse className='hidden sm:flex gap-10'>
            <ViewReverse className={'items-center gap-4'}>
              <Button
                text={user || isCorporateForm || isIndividualForm ? getContentKey('logout_btn') : getContentKey('login')}
                bgColor='bg-white'
                color='text-primary'
                icon={icons.logout_icon}
                className={'min-w-28 px-4 capitalize'}
                weight={TextWeight.medium}
                onClick={user || isCorporateForm || isIndividualForm ? toogleConfirmModal : () => navigate('/login')}
              />
              {!user && !isCorporateForm && !isIndividualForm && (
                <ViewReverse className={'gap-3 items-center cursor-pointer'} onClick={() => navigate('/help/faqs')} isReverse={false}>
                  <ReactSVG src={icons?.Faqs_icon} />
                  <Text text={getContentKey('faqs')} color={'text-white'} size={fontSizes.h15} />
                </ViewReverse>
              )}
              <Language />

              {user && (
                <ViewItems className={'max-w-48'}>
                  <Text text={clientDetails?.clientInformation?.clientName ?? ''} color={'text-white'} size={fontSizes.h15} isTruncate={true} />
                  <Text text={clientDetails?.clientInformation?.clientEmail ?? ''} color={'text-white'} size={fontSizes.h11} isTruncate={true} />
                </ViewItems>
              )}
            </ViewReverse>
          </ViewReverse>

          <div className={cn('flex items-center gap-3', isArabic ? 'sm:mr-3' : 'sm:ml-3', user && !(isCorporateForm || isIndividualForm) ? "xl:hidden" : "sm:hidden")}>
            <ReactSVG src={icons.menuList} className='cursor-pointer' onClick={toogleDrawer} />
          </div>
        </ViewReverse>
      </ViewReverse>

      <MobileMenu
        isDrawer={isDrawer}
        onClose={toogleDrawer}
        logoutText={user || isCorporateForm || isIndividualForm ? getContentKey('logout_btn') : getContentKey('login')}
        onLogout={user || isCorporateForm || isIndividualForm ? toogleConfirmModal : () => navigate('/login')}
        clientDetails={clientDetails}
        getContentKey={getContentKey}
        user={user}
        isCorporateForm={isCorporateForm}
        isIndividualForm={isIndividualForm}
      />

      <NotificationModal
        isOpen={isNotificationModal}
        onClose={toogleNotificationModal}
        targetEl={targetEl}
        onAlertClick={() => {
          toogleNotificationModal();
          toogleAlertModal();
        }}
      />

      {(user || client_application_id) && (
        <ConfirmModal
          open={confirmModal}
          onClose={toogleConfirmModal}
          title={getContentKey('logout_btn')}
          description={getContentKey('logout_confirmation')}
          loading={authLoading}
          onConfirm={handleLogout}
          acceptText={getContentKey('logout_btn')}
        />
      )}

      <AlertModal isOpen={isAlertModal} onClose={toogleAlertModal} />
      <ClientDetailModal isOpen={clientDetailModal} handleClose={() => setClientDetailModal(false)} />
      <LoaderModal open={languageLoading} />
    </div>
  );
};

export default DashboardHeader;
